import { gql } from "@apollo/client";

export default gql`
  mutation importAiHelpPdf($data: AiHelpImportPdfInput!){
    importAiHelpPdf(data: $data){
        success
        data{
            _id
            slug
            title
            category
            summary
            related
            author
            sourceDate
            source
            fileName
            panelPath
            permissions
            language
            sections{
                key
                heading
                text
                images{
                    key
                    url
                    caption
                    description
                }
            }
            faqs{
                question
                answer
            }
            status
            chunkCount
            indexedAt
            error
            useCount
            lastUsedAt
            createdAt
            updatedAt
        }
        code
        message
    }
}
`
